// extracted by mini-css-extract-plugin
module.exports = {"btnUp":"footer_btnUp__SF9w_","pagination":"footer_pagination__2seLc","liactive":"footer_liactive__3CFNI","footer":"footer_footer__1lZIc","pages":"footer_pages__3wfYb"};